export enum DeliveryType {
  DIGITAL_OR_PHYSICAL= 'DIGITAL_OR_PHYSICAL',
  DIGITAL_ONLY = 'DIGITAL_ONLY',
  PHYSICAL_ONLY = 'PHYSICAL_ONLY'
}
